import { Tab, Tabs } from '@resiliatech/birdsong'
import { FunderCollaborationTabsEnum } from '../_common/types'

type FunderSharedGoalTabsProps = {
  activeTab: FunderCollaborationTabsEnum
  onChangeTab: (tab: FunderCollaborationTabsEnum) => void
}

const tabs = [
  {
    label: 'Goal Group Creation',
    value: FunderCollaborationTabsEnum.goalGroupCreation,
  },
  { label: 'Goal Creation', value: FunderCollaborationTabsEnum.goalCreation },
  { label: 'Chart Creation', value: FunderCollaborationTabsEnum.chartCreation },
]

export const FunderSharedGoalTabs = ({
  activeTab,
  onChangeTab,
}: FunderSharedGoalTabsProps) => (
  <Tabs value={activeTab}>
    {tabs.map(({ label, value }) => (
      <Tab
        key={label}
        label={label}
        onClick={() => onChangeTab(value)}
        value={value}
        sx={{ textTransform: 'unset' }}
      />
    ))}
  </Tabs>
)
